import { I18n } from '@calendly/i18n'
import { ArrowRecurringIcon } from '@calendly/ui/components/icons'
import { BodyText, LabelText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'

import { Layout } from 'components/layout'
import { useEventType } from 'features/event_type_provider'

import { HeaderWithIcon, PanelContentContainer, PanelContentHeader } from '../styles'
import { EventTypeLevelAvailableHours } from './available_hours/event_type_level_available_hours'
import { BaseAvailability } from './base_availability'

const HeaderPart = (props) => <Layout gap="4" align="center" {...props} />

export const SingleUseLinkAvailability = ({ isReadOnly = false, isLocked = false }) => {
  const { isSolo, isUser } = useEventType()

  return (
    <BaseAvailability
      description={I18n.t('publisher.event_type_editor.sections.availability.hours.weekly_hours_for_all')}
    >
      <PanelContentContainer section>
        <PanelContentHeader withActions>
          <HeaderPart>
            <LabelText size="medium">
              {I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
              {': '}
              <BodyText size="medium" inline>
                {I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.custom_label')}
              </BodyText>
            </LabelText>
          </HeaderPart>
        </PanelContentHeader>
        <PanelContentHeader>
          <HeaderWithIcon>
            <ArrowRecurringIcon color={colorTextSecondary} />
            <BodyText size="medium">
              {I18n.t('publisher.event_type_editor.sections.available_hours.weekly_hours')}
            </BodyText>
          </HeaderWithIcon>
          <BodyText size="small" color="muted">
            {I18n.t('publisher.event_type_editor.sections.availability.hours.weekly_hours_for_all')}
          </BodyText>
        </PanelContentHeader>
      </PanelContentContainer>
      <EventTypeLevelAvailableHours
        formPath="shareOverrideAvailability"
        readOnly={isLocked || isReadOnly || !(isSolo && isUser)}
        fixTimezonePositioning
      />
    </BaseAvailability>
  )
}
